/*** IMPORTS FROM imports-loader ***/
var define = false;

var path = require('../internals/path');

module.exports = function (CONSTRUCTOR) {
  return path[CONSTRUCTOR + 'Prototype'];
};

